var React = require('react');

function TrashRed (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.357 3c1.065 0 1.929.863 1.929 1.929v.642h5.143v1.286h-1.286v12.214A1.929 1.929 0 0116.214 21h-9a1.929 1.929 0 01-1.928-1.929V6.857H4V5.571h5.143V4.93c0-1.067.863-1.93 1.927-1.93zm4.5 3.857H6.571v12.214c0 .355.288.643.643.643h9a.643.643 0 00.643-.643V6.857zm-4.5 2.572v7.714h-1.286V9.429h1.286zm2.572 0v7.714h-1.286V9.429h1.286zm-5.143 0v7.714H8.5V9.429h1.286zm2.571-5.143h-1.286a.643.643 0 00-.642.643v.642H13V4.93a.643.643 0 00-.643-.643z","fill":"#960000","fillRule":"evenodd"}));
}

TrashRed.defaultProps = {"width":"24","height":"24"};

module.exports = TrashRed;

TrashRed.default = TrashRed;
